/**
 * Runtime configuration (Vite env, baked in at build time).
 *
 * - VITE_API_URL: the API origin. Default http://localhost:8090.
 * - VITE_MOCK: 'true' serves the whole API from MSW in the browser; 'false' always uses the real API.
 *   When unset: mock in `vite --mode mock`; in plain `vite` dev, mock only if VITE_API_URL is
 *   also unset (so `pnpm dev` / the "web" preview work without the Rust API). Production builds
 *   never mock unless VITE_MOCK=true or `--mode mock`.
 */
const env = import.meta.env;

export const API_URL: string = (env.VITE_API_URL as string | undefined)?.replace(/\/+$/, '') || 'http://localhost:8090';

function resolveMock(): boolean {
  const flag = env.VITE_MOCK as string | undefined;
  if (flag === 'true') return true;
  if (flag === 'false') return false;
  if (env.MODE === 'mock') return true;
  if (env.MODE === 'api') return false;
  return Boolean(env.DEV) && !env.VITE_API_URL && env.MODE !== 'test';
}

export const MOCK: boolean = resolveMock();
